export default __webpack_public_path__ + "static/media/submitted-form-light.773a5cc0.svg";